export enum QueryStepValue {
  daily = 'DAILY',
  weekly = 'WEEKLY',
  monthly = 'MONTHLY',
}
